// extracted by mini-css-extract-plugin
module.exports = {"container":"preference-status-tag-group_container__XiACb","divider":"preference-status-tag-group_divider___mvA9"};